import api from '@/services/api'

export const baseActions = {
    getExecutives(context) {
        // if (! context.state.executives) {
            return new Promise((resolve) => {
                api('/executives?per_page=20')
                .then((data) => {
                    resolve(context.commit('saveExecutives', data))
                }).catch(() => true);
            });
        // }
    },
    getCurrentExecutive(context, to) {
        context.commit('setCurrentExecutive', to.to.params.slug)
    },
    setMapAvailable(context) {
        context.commit('setMapAvailable', true)
    },
    getEstates(context, currentPage = 1) {
        // if (! context.state.estates) {
            return new Promise((resolve) => {
                api(`/estates?per_page=20&page=${currentPage}`)
                .then((data) => {
                    resolve(context.commit('saveEstates', {data, currentPage}))
                }).catch(() => {
                    resolve(context.commit('noMoreEstates'))
                });
            });
        // }
    },
    getBlogData(context, currentPage = 1) {
        // if (! context.state.estates) {
            return new Promise((resolve) => {
                api(`/posts?per_page=5&page=${currentPage}`)
                .then((data) => {
                    resolve(context.commit('saveBlogPosts', { data, currentPage }))
                }).catch(() => {
                    resolve(context.commit('noMoreBlogPosts'))
                });
            });
        // }
    },
    getSiteData(context) {
        // if (! context.state.estates) {
            return new Promise((resolve) => {
                api('/site-data')
                .then((data) => {
                    resolve(context.commit('saveSiteData', data))
                }).catch(() => true);
            });
        // }
    },
    getContactOffices(context) {
        return new Promise((resolve) => {
            api('/contact-offices?per_page=20')
            .then((data) => {
                resolve(context.commit('saveContactOffices', data))
            }).catch(() => true);
        });
    },
    getContactData(context) {
        return new Promise((resolve) => {
            api('/contact-data?per_page=20')
            .then((data) => {
                resolve(context.commit('saveContactData', data))
            }).catch(() => true);
        });
    },
    getTestimonials(context) {
        return new Promise((resolve) => {
            api('/site-testimonials?per_page=20')
            .then((data) => {
                resolve(context.commit('saveTestimonials', data))
            }).catch(() => true);
        });
    },
    getHouses(context) {
        // if (! context.state.houses) {
            return new Promise((resolve) => {
                api('/houses?per_page=20')
                .then((data) => {
                    resolve(context.commit('saveHouses', data))
                }).catch(() => true);
            });
        // }
    },
    getSliders(context) {
        // if (! context.state.houses) {
            return new Promise((resolve) => {
                api('/home-slider?per_page=20')
                .then((data) => {
                    resolve(context.commit('saveSliders', data))
                }).catch(() => true);
            });
        // }
    },
    getCurrentHouse(context, to) {
        context.commit('setCurrentHouse', to.to.params.houseSlug)
    },
    sendSubscription(context, data) {
        context.commit('setSubscribeStatus', true)
        return new Promise((resolve) => {
            api('/newsletter/v1/subscribe', data, 'POST', 'https://api.revolutionplusproperty.com/wp-json')
            .then(() => {
                const message = `Hi ${data.name}, \n
                Your email ${data.email} has been successfully subscribed to our newsletter. \n
                Thank you`
                resolve(context.commit('subscribe', message))
            }).catch((error) => {
                resolve(context.commit('subscribe', error.response.data.message))
            });
        });
    },
    resetSubscribe(context) {
        context.commit('resetSubscribe')
    },
    getPrivacyData(context) {
        // if (! context.state.articles) {
            return new Promise((resolve) => {
                api('/pages/23327')
                .then((data) => {
                    resolve(context.commit('savePrivacy', data))
                }).catch(() => true);
            });    
        // }
    },
    getArticles(context) {
        // if (! context.state.articles) {
            return new Promise((resolve) => {
                api('/articles?per_page=20')
                .then((data) => {
                    context.commit('saveArticles', data)
                    api('/home-articles')
                    .then((homeArticles) => {
                        resolve(context.commit('saveHomeArticles', homeArticles));
                    }).catch(() => true);
                }).catch(() => true);
            });    
        // }
    },
    loadingState(context, data) {
        context.commit('setLoadingState', data)
    },
    getSingleArticle(context, to) {
        context.commit('setCurrentArticle', to.to.params.title)
    },
    subscribe(context, data) {
        return new Promise((resolve) => {
            api(data, true)
            .then((data) => {
                resolve(data)
            })
        })
    }
}